import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=dcd074be&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcd074be')) {
      api.createRecord('dcd074be', component.options)
    } else {
      api.reload('dcd074be', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=dcd074be&", function () {
      api.rerender('dcd074be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-243RxGj6pTbjm/JS/comp/FavElement.vue"
export default component.exports